module.exports = __webpack_public_path__ + "img/apple.4546099b.png";